import React from "react";
import Input from "../FormComponents/Input";
import { NewIconSelector } from "../BuilderComponents/Preview/IconPreview";

const EditDownloadFileManager = ({ setEditElementData, editElementData }) => {
  const handleEditElementData = (type, value) => {
    setEditElementData({ ...editElementData, [type]: value });
  };
  const handleChange = (e) => {
    handleEditElementData(e.target.name, e.target.value);
  };

  return (
    <div className="builder_form">
      <Input label="Enter Title" name="title" value={editElementData.title} onChange={handleChange} />
      <NewIconSelector onChange={(newIcon) => handleEditElementData("icon", newIcon)} icon={editElementData.icon} />
    </div>
  );
};

export default EditDownloadFileManager;
